'use client';

export { appendOwnerState } from './appendOwnerState';
export { areArraysEqual } from './areArraysEqual';
export { ClassNameConfigurator } from './ClassNameConfigurator';
export { extractEventHandlers } from './extractEventHandlers';
export { isHostComponent } from './isHostComponent';
export { resolveComponentProps } from './resolveComponentProps';
export { useSlotProps } from './useSlotProps';
export { mergeSlotProps } from './mergeSlotProps';
export * from './PolymorphicComponent';
export * from './types';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/base/utils/index.js
// module id = 59
// module chunks = 31